import React from 'react'
import { observer } from 'mobx-react-lite'

import ViewStudents from './components/ViewStudents'
import SendMessageModal from './components/SendMessageModal/SendMessageModal'
import { ListsTabs } from '../../widgets/ListsTabs/ListsTabs'
import { useStudentsPage } from './hooks/useStudentsPage'
import AssignActivityModal from 'widgets/AssignActivityModal/AssignActivityModal'

import { ReactComponent as ListIcon } from '../../assets/icons/list.svg'
import { FiltersSortBar } from 'widgets/FiltersSortBar/FiltersSortBar'
import { useFiltersSortBarStudents } from './hooks/useFiltersSortBarStudents'
import { FiltersPanel } from 'widgets/FiltersPanel/FiltersPanel'
import FiltersStudentsContent from './components/FiltersStudentsContent/FiltersStudentsContent'

import s from './styles/StudentsPage.module.scss'
// import BookSessionModal from 'widgets/BookSessionModal/BookSessionModal'

export const StudentsPage = observer(() => {
	const {
		activeGrade,
		selectedStudents,
		// savedLists,
		isSendModalOpen,
		// applySavedList,
		openSendModal,
		closeSendModal,
		setGrade,
		tabs,
		actions,
		isOpenFilter,
		closeFilter,
		isAssignActivityOpen,
		openAssignActivityModal,
		closeAssignActivityModal,
		// isBookSessionOpen,
		// openBookSessionModal,
		// closeBookSessionModal,
		isLoading,
		error,
	} = useStudentsPage()

	const {
		isVisible,
		baseItems,
		activeIds,
		extraItems,
		onBaseChange,
		onRemoveExtra,
		onSortChange,
		setExtraItems,
	} = useFiltersSortBarStudents()

	return (
		<div className={s.page}>
			<div className={s.container}>
				<div className={s.content}>
					<div className={s.tabs}>
						<ListsTabs
							badgeIcon={ListIcon}
							badgeText="Lists:"
							selectPrefixIcon={ListIcon}
							selectPrefixText="Lists:"
							tabs={tabs}
							activeTab={activeGrade}
							onSelect={setGrade}
							actions={actions}
							className={s.tab}
						/>
					</div>

					{isVisible && (
						<div className={s.filtersSortBar}>
							<FiltersSortBar
								baseItems={baseItems}
								activeIds={activeIds}
								onChange={onBaseChange}
								extraItems={extraItems}
								onRemoveExtra={onRemoveExtra}
								showSearch={false}
							/>
						</div>
					)}

					<div className={s.inner}>
						<div className={s.main}>
							{error ? (
								<div
									style={{ padding: '2rem', textAlign: 'center', color: 'red' }}
								>
									<p>Error: {error}</p>
									<p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>
										Please check your connection and try again.
									</p>
								</div>
							) : (
								<ViewStudents
									onOpenSendMessage={openSendModal}
									onOpenAssignActivity={openAssignActivityModal}
									// onOpenBookSession={openBookSessionModal}
									isOpenFilter={isOpenFilter}
									isLoading={isLoading}
									onSortChange={({ opt, name }) => {
										onSortChange(opt)
										setExtraItems([
											{
												id: 'sort',
												label: `${name}: ${opt.label}`,
												isActive: true,
												removable: true,
												onClick: () => {},
											},
										])
									}}
								/>
							)}
						</div>
					</div>
				</div>
				<FiltersPanel isOpen={isOpenFilter} onClose={closeFilter}>
					<FiltersStudentsContent onClose={closeFilter} />
				</FiltersPanel>
			</div>

			<SendMessageModal
				isOpen={isSendModalOpen}
				onClose={closeSendModal}
				selectedStudents={selectedStudents}
				// savedLists={savedLists}
				// onSelectList={applySavedList}
			/>

			<AssignActivityModal
				isOpen={isAssignActivityOpen}
				onClose={closeAssignActivityModal}
				selectedStudents={selectedStudents}
				// savedLists={savedLists}
				activeGrade={activeGrade}
				// onSelectList={applySavedList}
				onSetGrade={setGrade}
				clearSelectionOnOpen={false}
			/>

			{/* <BookSessionModal
				isOpen={isBookSessionOpen}
				onClose={closeBookSessionModal}
				selectedStudents={selectedStudents}
				// savedLists={savedLists}
				// onSelectList={applySavedList}
			/> */}
		</div>
	)
})
